import React from "react";
import { Suspense } from "react";
import { Navigate } from "react-router-dom";
import ThemeSpinner from "src/components/ThemeSpinner";
import { allRoutes } from "src/constants/AllRoutes";
import { checkUserPermission } from "src/utils/users";

type PermitRoutesProps = {
  permission: {
    type: string;
    value: string;
  };
  path: string;
  Component: any;
};

function PermitRoutes({ permission, Component }: PermitRoutesProps) {
  const isAllowed = checkUserPermission(permission.type, permission.value);
  return isAllowed ? (
    <Suspense fallback={<ThemeSpinner />}>
      <Component />
    </Suspense>
  ) : (
    <Navigate to={allRoutes.dashboard} />
  );
}

export default PermitRoutes;
